import { request } from '@/utils/request'

// 获取小视频类型
export function getZcjSmallVideoType(params: any) {
  return request({
    url: '/smallVideo/getZcjSmallVideoType',
    params,
    method: 'GET',
  })
}

// 获取小视频列表
export function getZcjSmallVideoList(params: any) {
  return request({
    url: '/smallVideo/getZcjSmallVideoList',
    params,
    method: 'GET',
  })
}

// 所有课程
export function getCurriculum(params: any) {
  return request({
    url: '/zhongcaijie/h5/classRoom/getCurriculum',
    params,
    method: 'GET',
  })
}

// 课程详情
export function getH5ClassRoomInfoBackstage(params: any) {
  return request({
    url: '/zhongcaijie/h5/classRoom/getH5ClassRoomInfoBackstage',
    params,
    method: 'GET',
  })
}

// 所有课时
export function getCurriculumHourList(params: any) {
  return request({
    url: '/zhongcaijie/h5/classRoom/getCurriculumHourList',
    params,
    method: 'GET',
  })
}

// 课时详情
export function getH5ClassHourInfoBackstage(params: any) {
  return request({
    url: '/zhongcaijie/h5/classRoom/getH5ClassHourInfoBackstage',
    params,
    method: 'GET',
  })
}

// 播放地址
export function getPlayUrl(params: any) {
  return request({
    url: '/api/alivod/h5/getPlayUrl',
    params,
    method: 'POST',
  })
}

// 播放凭证
export function getVideoPlayVoucher(params: any) {
  return request({
    url: '/api/alivod/h5/getVideoPlayVoucher',
    params,
    method: 'POST',
  })
}

// 视频详情
export function getZcjSmallVideoDetails(params: any) {
  return request({
    url: '/smallVideo/getZcjSmallVideoDetails',
    params,
    method: 'GET',
  })
}

// 收藏课程列表
export function getCollectionCurriculum(params: any) {
  return request({
    url: '/zhongcaijie/h5/classRoom/getCollectionCurriculum',
    params,
    method: 'GET',
  })
}

// 课程点击量
export function updateClassRoomClicks(params: any) {
  return request({
    url: '/zhongcaijie/h5/classRoom/updateClassRoomClicks',
    params,
    method: 'GET',
  })
}

// 首页推荐
export function getHomeCurriculumList() {
  return request({
    url: '/zhongcaijie/h5/classRoom/getHomeCurriculumList',
    method: 'GET',
  })
}

// 随机小视频-精品数据
export function getZcjSmallVideo(params: any) {
  return request({
    url: '/smallVideo/getZcjSmallVideo',
    method: 'GET',
    params,
  })
}

// 获取开启的课程类型
export function getAllClassRoomType() {
  return request({
    url: '/zhongcaijie/h5/classRoom/getAllClassRoomType',
    method: 'GET',
  })
}
